/**
 * Утилиты для работы с матрицей процессов.
 * Схема строки: [category, product, action, teamNumber, w1..w5, code]
 * Индексы: 0=роль, 1=действие, 2=метод, 3=номер команды, 4-8=веса, 9=код
 */

export const MATRIX_COLUMNS = {
  CATEGORY: 0,
  PRODUCT: 1,
  ACTION: 2,
  TEAM_NUMBER: 3,
  COMPLIANCE: 4,
  SPEED: 5,
  QUALITY: 6,
  PATIENT_CENTRICITY: 7,
  DIGITAL_MATURITY: 8,
  CODE: 9,
};

export const filterMatrixRow = (row, filters) => {
  if (filters.category && row[MATRIX_COLUMNS.CATEGORY] !== filters.category) return false;
  if (filters.product && row[MATRIX_COLUMNS.PRODUCT] !== filters.product) return false;
  if (filters.action && row[MATRIX_COLUMNS.ACTION] !== filters.action) return false;
  return true;
};

export const extractTeamNumber = (teamName) => {
  const match = String(teamName || '').match(/\d+/);
  return match ? match[0] : null;
};

export const findMatrixRow = (matrix, { category, product, action, teamName }) => {
  const teamNumber = extractTeamNumber(teamName);
  return matrix.find((row) => {
    if (row[MATRIX_COLUMNS.CATEGORY] !== category) return false;
    if (row[MATRIX_COLUMNS.PRODUCT] !== product) return false;
    if (row[MATRIX_COLUMNS.ACTION] !== action) return false;
    if (teamNumber && row[MATRIX_COLUMNS.TEAM_NUMBER] !== teamNumber) return false;
    return true;
  });
};

export const findMatrixRowByCode = (matrix, code, teamName) => {
  const teamNumber = extractTeamNumber(teamName);
  return matrix.find((row) => {
    if (row[MATRIX_COLUMNS.CODE] !== code) return false;
    if (teamNumber && row[MATRIX_COLUMNS.TEAM_NUMBER] !== teamNumber) return false;
    return true;
  });
};

export const filterMatrixByTeam = (matrix, teamName) => {
  const teamNumber = extractTeamNumber(teamName);
  if (!teamNumber) return matrix;
  return matrix.filter((row) => row[MATRIX_COLUMNS.TEAM_NUMBER] === teamNumber);
};
